'use strict'

var PageComponent = require('src/components/page-view')

/**
 *
 * -----------------------------------------------------------------------------
 */
var Layout = PageComponent.LayoutPageTabs.extend({
  className: 'page page-client',
  initialize: function () {
    PageComponent.Layout.prototype.initialize.apply(this, arguments)
    this.setTitle()
    // if the model changes update the title
    this.listenTo(this.model, 'change', this.setTitle)
  },
  setTitle: function () {
    this.options.pageModel.set('title', this.model.get('name'))
  },
  modelEvents: {
    'change': 'render'
  }
})

module.exports.Layout = Layout



// WEBPACK FOOTER //
// ./js/modules/page-clients/show/view.js